import { render, staticRenderFns } from "./BuscadorHomeComp.vue?vue&type=template&id=c7631430&scoped=true&"
import script from "./BuscadorHomeComp.vue?vue&type=script&lang=js&"
export * from "./BuscadorHomeComp.vue?vue&type=script&lang=js&"
import style0 from "./BuscadorHomeComp.vue?vue&type=style&index=0&id=c7631430&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7631430",
  null
  
)

export default component.exports